/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// import { XMarkIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState, useRef, useMemo } from "react";

// import PageHeadline from "../../components/shared/PageHeadline";

// import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'

import GalleryLoading from "../../components/shared/GalleryLoading";
// import galleryConfigss from "../../constant/gallery";
import fetchGallery from "../../helper/getGallery";

const DEFAULT_GALLERY_YEAR = 2026;

export default function Index() {
    // const { t } = useTranslation();
    const locale = useSelector((state) => state.locale.locale);

    const [galleryConfigs, setGalleryConfigs] = useState({
        galleryConfig2025: {
            eventName: "",
            locations: []
        },
        galleryConfig2026: {
            eventName: "",
            locations: []
        }
    });

    const [configLoaded, setConfigLoaded] = useState(false);

    useEffect(() => {
        const fetchGalleryConfig = async () => {
            try {
                // https://bandoeng10k.com/dev.titudev.com//api/v1/resources/master_file_tagging?filter%5BmftgEventName%5D=bank+bjb+Bandoeng+10K+2026&pageNumber=1&pageSize=20
                const response = await fetch('https://bandoeng10k.com/dev.titudev.com//api/v1/resources/gallery_location?filter[mglcGaleId]=4', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const response2026 = await fetch('https://bandoeng10k.com/dev.titudev.com//api/v1/resources/gallery_location?filter[mglcGaleId]=9', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                const data2026 = await response2026.json();
                const config = {
                    galleryConfig2025: {
                        eventName: data.linked.mglcGaleId[0].galeNameKey,
                        locations: data.data.map((location) => {
                            return location.mglcKey
                        })
                    },
                    galleryConfig2026: {
                        eventName: data2026.linked.mglcGaleId[0].galeNameKey,
                        locations: data2026.data.map((location) => {
                            return location.mglcKey
                        })
                    }
                };
                setGalleryConfigs(config);
                setConfigLoaded(true);
            } catch (err) {
                console.error("Error fetching gallery config:", err);
            }
        }

        fetchGalleryConfig();
    }, [])

    const config2025 = galleryConfigs && galleryConfigs.galleryConfig2025;
    const config2026 = galleryConfigs && galleryConfigs.galleryConfig2026;

    const [galleryData, setGalleryData] = useState([]);
    const [totalGalleryData, setTotalGalleryData] = useState(null);

    const [isLoading, setLoading] = useState(false);
    const [activeYear, setActiveYear] = useState(DEFAULT_GALLERY_YEAR);
    const [configSelected, setConfigSelected] = useState(
        galleryConfigs.galleryConfig2026
    );
    const [locationOption, setLocationOption] = useState([]);
    const [activeLocation, setActiveLocation] = useState({
        year: activeYear,
        value: "",
    });

    // Update configSelected when gallery configs are loaded
    useEffect(() => {
        const cfg2026 = galleryConfigs.galleryConfig2026;
        const cfg2025 = galleryConfigs.galleryConfig2025;
        if (DEFAULT_GALLERY_YEAR === 2026 && cfg2026?.eventName) {
            setConfigSelected(cfg2026);
            setLocationOption(cfg2026.locations);
        } else if (cfg2025?.eventName) {
            setConfigSelected(cfg2025);
            setLocationOption(cfg2025.locations);
        }
    }, [galleryConfigs]);

    // eslint-disable-next-line no-unused-vars
    const [pageNumber, setPageNumber] = useState(1);
    const [inputValue, setInputValue] = useState(""); // Menyimpan value langsung dari input
    const [endOfPage, setEndOfPage] = useState(false);
    const [isComingSoon, setIsComingSoon] = useState(false);

    // Debounced search value
    const [debouncedValue, setDebouncedValue] = useState(""); 

    const btnClassYear =
        "!text-brandGrey px-6 py-3 rounded-lg hover:!text-brandBlue transition-all duration-300 text-white";

    const btnClass =
        "!text-brandGrey px-4 py-2 bg-brandGrey/50 rounded-lg hover:bg-[#edcd38] hover:text-brandBlue transition-all duration-500 !text-brandBlue font-bold";

    const switchYear = async (year) => {
        setPageNumber(1);
        setGalleryData([]);
        setActiveYear(year);
        setInputValue("");
        setDebouncedValue("");
        setEndOfPage(false);
        setActiveLocation({
            year: year,
            value: "",
        });

        if (year === 2025) {
            setIsComingSoon(false);
            setConfigSelected(config2025);
            setLocationOption(config2025.locations);
        } else if (year === 2026) {
            setIsComingSoon(false);
            setConfigSelected(config2026);
            setLocationOption(config2026.locations);
        }
    };

    const switchLocation = async (year, value) => {
        setPageNumber(1);
        setGalleryData([]);
        setEndOfPage(false);
        setActiveLocation({
            year: year,
            value: value,
        });
    };

    const handleChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        // Clear gallery data immediately when typing
        if (newValue !== debouncedValue) {
            setGalleryData([]);
        }
        setEndOfPage(false);
        setPageNumber(1);
    };

    // Define debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    // Create a memoized version of the scroll handler
    const debouncedHandleScroll = useMemo(() =>
        debounce(() => {
            if (document.body.scrollHeight - 500 < window.scrollY + window.innerHeight) {
                // Only proceed if we have data and haven't reached the end
                if (galleryData.length > 0 && !isLoading && !endOfPage) {
                    // Check if we've loaded all available data
                    if (totalGalleryData && galleryData.length >= totalGalleryData) {
                        setEndOfPage(true);
                    } else {
                        // Only fetch more data if we haven't loaded everything
                        setPageNumber(prevPage => prevPage + 1);
                    }
                }
            }
        }, 300),
        [galleryData.length, totalGalleryData, isLoading, endOfPage]
    );

    // Add and remove scroll event listener with cleanup
    useEffect(() => {
        window.addEventListener("scroll", debouncedHandleScroll);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener("scroll", debouncedHandleScroll);
        };
    }, [debouncedHandleScroll]);

    // Debounce the search input
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (inputValue !== debouncedValue) {
                setDebouncedValue(inputValue);
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [inputValue, debouncedValue]);

    // Handle data fetching when search or location changes
    useEffect(() => {
        // Reset page number and gallery data when search or location changes
        setPageNumber(1);
        if (configLoaded) {
            fetchData();
        }
    }, [debouncedValue, activeLocation.value, configLoaded]);

    // Handle pagination loading
    useEffect(() => {
        if (pageNumber > 1 && configLoaded && !isLoading) {
            setLoading(true);
            fetchData();
        }
    }, [pageNumber, configLoaded]);

    // Load data when component mounts or year changes
    useEffect(() => {
        if (configLoaded) {
            fetchData();
        }
    }, [activeYear, configSelected, configLoaded]);


    const fetchData = async () => {
        if (endOfPage) return;

        // Don't fetch if eventName is not available yet
        if (!configSelected || !configSelected.eventName) {
            return;
        }

        if (!isLoading) setLoading(true);

        try {
            const response = await fetchGallery(
                configSelected.eventName,
                activeLocation?.value,
                pageNumber,
                debouncedValue
            );

            if (response === null) {
                setGalleryData([]);
                setTotalGalleryData(0);
                setEndOfPage(true);
            } else {
                setTotalGalleryData(response.status.totalRecords);

                // If no data received, mark as end of page
                if (response.data.length === 0) {
                    setEndOfPage(true);
                } else if (pageNumber === 1) {
                    // Replace data on first page
                    setGalleryData(response.data);
                    // If we got less data than total, we're at the end
                    if (response.data.length >= response.status.totalRecords) {
                        setEndOfPage(true);
                    }
                } else {
                    // Append data for pagination
                    setGalleryData(currentData => {
                        const newData = [...currentData];
                        response.data.forEach(item => {
                            if (!newData.some(existing => existing.id === item.id)) {
                                newData.push(item);
                            }
                        });
                        // If we've loaded all data, mark as end of page
                        if (newData.length >= response.status.totalRecords) {
                            setEndOfPage(true);
                        }
                        return newData;
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching gallery data:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white relative">
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("galleryTitle")} />
            </div> */}
            <div className="flex mx-auto px-4 items-start justify-start z-10 min-h-screen 2xl:pt-56 md:pt-40 pt-24 w-full bg-white bg-no-repeat">
                <div className="2xl:px-0 md:px-14 px-4 w-full py-4">
                    <div className="w-full font-poppins text-[#164481]">
                        <div className="container h-full mx-auto w-full">
                            <div className="w-full mb-8">
                                <div className="space-y-4">
                                    <div className="space-y-4 flex max-md:flex-wrap">
                                        <div className="basis-full md:basis-4/12">
                                            <div className={`${locale === 'en' ? 'bg-galleryEn' : 'bg-galleryId'} bg-contain bg-no-repeat bg-top min-h-[180px]`}></div>
                                        </div>
                                        <div className="basis-full md:basis-8/12 h-full space-y-4">
                                            <div className="flex md:flex-row flex-col items-center justify-between md:gap-y-0 gap-y-6">
                                                <h1 className="2xl:text-5xl text-3xl uppercase font-bold max-w-2xl italic">
                                                    {/* Race Gallery */}
                                                </h1>
                                                {!isComingSoon && <div className="max-md:w-full max-md:flex max-md:justify-end max-md:gap-x-4 md:space-x-4">
                                                    {/* <button
                                                        onClick={() => switchYear(2022)}
                                                        className={`${btnClass} ${
                                                            activeYear === 2022 ? "bg-[#edcd38]" : null
                                                        }`}
                                                    >
                                                        2022
                                                    </button> */}
                                                    <button
                                                        onClick={() => switchYear(2026)}
                                                        className={`text-lg ${btnClassYear} ${activeYear === 2026 ? "!text-brandBlue font-bold" : null
                                                            }`}
                                                    >
                                                        2026
                                                    </button>
                                                    <button
                                                        onClick={() => switchYear(2025)}
                                                        className={`text-lg ${btnClassYear} ${activeYear === 2025 ? "!text-brandBlue font-bold" : null
                                                            }`}
                                                    >
                                                        2025
                                                    </button>
                                                </div>}
                                            </div>
                                            <div className="md:px-0 px-6">
                                                <input
                                                    id="name"
                                                    name="name"
                                                    type="text"
                                                    className="bg-brandYellow block border w-full 2xl:py-6 2xl:px-6 px-4 py-2 rounded-lg placeholder:text-white text-white"
                                                    placeholder="Search your BIB here"
                                                    value={inputValue}
                                                    onChange={handleChange}
                                                    disabled={isComingSoon}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-wrap justify-center gap-4 md:px-0 px-2">
                                        {!isComingSoon &&
                                            locationOption.map((value, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() =>
                                                    {
                                                        if (activeLocation.value === value) {
                                                            switchLocation(activeLocation, "")
                                                        } else {
                                                            switchLocation(activeLocation, value)
                                                        }
                                                    }
                                                    }
                                                    className={`${btnClass} text-xs ${
                                                        activeLocation?.value === value
                                                            ? "bg-[#efca18] !text-[#164481]"
                                                            : null
                                                    }`}
                                                >
                                                    {value}
                                                </button>
                                            ))}
                                    </div>
                                    <div className="flex flex-wrap justify-center gap-4 md:px-0 px-2 font-bold text-sm">
                                        {totalGalleryData === 0 && !isComingSoon && <span>Image not found with specified keyword.</span>}
                                        {totalGalleryData > 0 && <span>{totalGalleryData} photo(s) uploaded.</span>}
                                    </div>
                                    <div className="p-5 sm:p-8">
                                        {isComingSoon ? (
                                            <h1 className="text-center font-bold italic lg:text-7xl">
                                                Coming Soon
                                            </h1>
                                        ) : (
                                                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 md:grid-cols-3 lg:grid-cols-4">
                                                    <Gallery options={{
                                                        padding: { top: 20, bottom: 40, left: 10, right: 10 },
                                                    }}>
                                                        {galleryData.map((item, index) => {
                                                            let metaWidth = JSON.parse(item.mftgMeta) && JSON.parse(item.mftgMeta).width ? Math.round(JSON.parse(item.mftgMeta).width / 5) : 600;

                                                            return (
                                                                <div className="rounded-lg" key={index}>
                                                                    <Item key={index} original={item.mftgUrl} thumbnail={`${item.mftgUrl}/width/${metaWidth}`} width={JSON.parse(item.mftgMeta).width} height={JSON.parse(item.mftgMeta).height}>
                                                                        {({ ref, open }) => (
                                                                            <img ref={ref} onClick={open} src={`${item.mftgUrl}/width/${metaWidth}`} alt={item.mftgDescription} className="rounded-lg cursor-zoom-in" />
                                                                        )}
                                                                    </Item>
                                                                </div>
                                                            )
                                                        }
                                                        )}
                                                    </Gallery>
                                                    {isLoading === true && endOfPage === false && <GalleryLoading />}
                                            </div>
                                        )}
                                    </div>
                                    {endOfPage && <p className="text-center font-bold text-lg">You have reach the end of page.</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
